<template>
  <div class="background_news">
    <div class="news_index_text">
      <p style="font-size: 22px;margin-bottom: 1vh">Our Advantages</p>
      <p style="font-size: 20px;margin: 0">Over the past 12 years,</p>
      <p style="font-size: 20px;margin: 0">SIG has focused on technology/media,</p>
      <p style="font-size: 20px; margin-bottom: 0;">consumer/modern services, </p>
      <p style="font-size: 20px; margin-bottom: 3vh;">healthcare/green technologies.</p>
      <p style="font-size: 12px">We are interested in new business models, and we pay close </p>
      <p style="font-size: 12px">attention to technology innovations,but most important of all,</p>
      <p style="font-size: 12px"> we value the gift and potential of entrepreneurs.</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "News_index_en_m",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.news_index_text {
  padding-top: 34vh;
  text-align: center;
}

.background_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

</style>